import { GalleryService } from '../../gallery.service';
import { NbDialogRef } from '@nebular/theme';
import { Component, Input, OnInit } from '@angular/core';
import { GalleryRecord, initGalleryRecord, PlantGalleryRecord } from 'shared';
import { Slide } from 'shared';
import ImageViewer from 'awesome-image-viewer';

@Component({
  selector: 'app-gallery-record-dialog',
  templateUrl: './gallery-record-dialog.component.html',
  styleUrls: ['./gallery-record-dialog.component.scss']
})
export class GalleryRecordDialogComponent implements OnInit {
  @Input() record: GalleryRecord | PlantGalleryRecord = initGalleryRecord();
  @Input() recordId: string;
  imageSlides: Slide[] = [];
  constructor(
    public ref: NbDialogRef<GalleryRecordDialogComponent>,
    private galleryService: GalleryService
  ) {}

  async ngOnInit(): Promise<void> {
    if (this.recordId) {
      this.record = await this.galleryService.getGalleryRecordById(this.recordId);
    }
    this.imageSlides = this.record.thumbnails
      .filter((t, index) => {
        // return the large thumb 1024
        return index % 3 === 2;
      })
      .map((photo) => {
        return {
          src: photo.downloadURL,
          url: photo.downloadURL,
          templateName: this.record.name,
          filePath: photo.path,
          openUrlNewWindow: true
        };
      });
  }

  viewImages() {
    new ImageViewer({
      images: this.record.thumbnails
        .filter((t, index) => {
          // return the large thumb 1024
          return index % 3 === 2;
        })
        .map((photo) => {
          return {
            mainUrl: photo.downloadURL,
            thumbnailUrl: photo.downloadURL,
            description: this.record.name
          };
        })
    });
  }
}
